import PdfConsentimentos from "./PdfConsentimentos";

function PdfConsentimentosWrapper({ showPreviousPage, consentimentoData }) {
  const showPreviousP = () => {
    showPreviousPage();
  };

  return (
    <div>
      <PdfConsentimentos
        consentimentoData={consentimentoData}
        showPreviousPage={showPreviousP}
      />
    </div>
  );
}

export default PdfConsentimentosWrapper;
